if (!customElements.get('sku-conditional-block')) {
  class SkuConditionalBlock extends HTMLElement {
    connectedCallback() {
      this.allowed = (this.dataset.allowedSkus || '')
        .split(',')
        .map((sku) => sku.trim().toLowerCase())
        .filter(Boolean);

      this.update(this.dataset.currentSku);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sku = event?.data?.variant?.sku ?? event?.detail?.variant?.sku;
          this.update(sku);
        });
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    update(sku) {
      const normalized = (sku || '').trim().toLowerCase();
      const show = this.allowed.length === 0 || (normalized && this.allowed.includes(normalized));
      this.hidden = !show;
      this.style.display = show ? '' : 'none';
    }
  }

  customElements.define('sku-conditional-block', SkuConditionalBlock);
}
